import crudHandlers from "./_crud";
import {convertToArrayObject} from "../../utils/index"

const entity = "company_data";

const initialState = {
  entities: {},
  is_fetching: false,
  active: undefined,
  offset: 0,
  order: 0,
  lastReached: false,
  noMoreEntities: false,
};

export default (state = initialState, action) => {
  const { type, response, payload, increaseOffset=true } = action;
  switch (type) {
    case `LOAD_${entity.toUpperCase()}S_AND_REMAINS`: {
      //  It first transform the array into an object.
      const resOrdered = response.map((i, idx) => ({
        ...i,
        order: (state.order ?? 0) + idx + 1,
      }));

      let items = convertToArrayObject(resOrdered);

      return {
        ...state,
        entities: { ...state.entities, ...items },
        offset: increaseOffset
          ? (state?.offset ?? 0) + response?.length
          : state?.offset,
        order: resOrdered[resOrdered?.length - 1]?.order ?? state.order,
        is_fetching: false,
        noMoreEntities: response?.length != 7 || response?.length == 0,
      };
    }
    case `FETCH_${entity.toUpperCase()}S`: {
      return {
        ...state,
        is_fetching: payload ?? !state?.is_fetching,
      };
    }
    case `UNLOAD_${entity.toUpperCase()}S`: {
      return {
        entities: {},
        offset: 0,
        order: 0,
        is_fetching: false,
        noMoreEntities: false,
      };
    }
    case `NO_MORE_${entity.toUpperCase()}S`: {
      return {
        ...state,
        noMoreEntities: payload ? payload : !state?.noMoreEntities,
      };
    }
    case "LOGOUT": {
      return initialState;
    }
    default:
      state = crudHandlers(state, action, entity);

      return state;
  }
};
